<template>
    <banner-cta @dismissed="dismissed" v-if="shouldShow" class="hidden-print">
        <div slot="icon">
            <i class="icons8-checkmark-2" v-if="states.optedIn"/>
            <i class="icons8-bell" v-else/>
        </div>
        <div slot="text">
            <p v-if="states.optedIn"><strong>{{$t('components.thanks')}}</strong> {{$t('components.your-preferences-were-updated-you-can-update-this-at-any-time-in-your-notification-settings')}}</p>
            <p v-else><span v-html="$t('components.opt-in-here-if-you-would-like-to-be-one-of-the-first-to-hear-about-our-strong-new-discounts-promotions-strong')"/></p>
        </div>
        <div slot="button" v-if="!states.optedIn">
            <button class="btn btn-dark" @click.prevent="optIn" :disabled="states.loading">
                <template v-if="states.loading">
                    <i class="fa fa-spinner"/> {{$t('components.saving-ellipsis')}}
                </template>
                <template v-else>
                    {{$t('components.opt-in')}}
                </template>
            </button>
        </div>
    </banner-cta>
</template>

<script>
    import BannerCta from './BannerCTA';
    import UserRepository from '../../repositories/UserRepository';
    import Cookie from 'js-cookie';

    export default {
        name: 'opt-in-banner',

        components: { BannerCta },

        data() {
            return {
                states: {
                    loading: false,
                    optedIn: false,
                },
            };
        },

        computed: {
            shouldShow() {
                return !Cookie.get('opt-in-banner-dismissed');
            },
        },

        methods: {
            /**
             * Update the users marketing status
             */
            optIn() {
                this.states.loading = true;
                UserRepository.patch({
                    marketing_consent_given: true,
                }).then(() => {
                    this.states.loading = false;
                    this.states.optedIn = true;
                }).catch(() => {
                    this.states.loading = false;
                });
            },

            /**
             * Handle when the banner is dismissed
             * Only set when they're not dismissing
             * after successfully opting in
             */
            dismissed() {
                if (this.states.optedIn) {
                    return;
                }
                Cookie.set('opt-in-banner-dismissed', true, {
                    expires: 30, // Days
                });
            },
        },
    }
</script>
